var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramBurgerWhite = function SvgTelegramBurgerWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.878,
    height: 49.878,
    x: 0.092,
    y: 0.355,
    fill: "#717172",
    rx: 24.939
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.006 16.07-3.748 19.564s-.524 1.357-1.964.706l-8.647-6.865-.04-.02a5963 5963 0 0 0 10.62-9.902c.613-.592.233-.944-.479-.497L17.37 27.854l-5.161-1.798s-.812-.3-.89-.95c-.08-.652.917-1.004.917-1.004l21.04-8.548s1.73-.787 1.73.516"
  })));
};
export default SvgTelegramBurgerWhite;